import { Dispatch, SetStateAction, useState } from "react";
import TextArea from "../../common/TextArea";
import { Story } from "../../common/Common";
import AddImageForm from "../AddImageForm";
import styles from './StoryForm.module.css'

interface StoryFormProps {
    data?: Story;
    setIsEmpty?: Dispatch<SetStateAction<boolean>>;
}

const StoryForm = (props: StoryFormProps) => {
    const [content, setContent] = useState<string>(props.data ? props.data.content : "");

    const getInputValue = (value: string) => {
        content && setContent(value);
        if (props.setIsEmpty) {
            props.setIsEmpty(value.trim() === "" ? true : false); // 글이 비어있으면 true, 아니면 false
        }
    };

    return (
        <div className={styles.container}>
            <TextArea name={"content"} cols={40} rows={10} maxLength={200} getInputValue={getInputValue} defaultValue={content} placeholder="이 장소에 대해 나누고 싶은 이야기를 자유롭게 입력해주세요."/>
            <AddImageForm limit={10} savedImages={(props.data && props.data.images) ?? []} />
        </div>
    );
};

export default StoryForm;
